import { useEffect, useState } from "react";
import MaterialBox from "../../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialInput from "../../../../components/MaterialInput";
import {
  CardContent,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Switch,
} from "@mui/material";
import MaterialButton from "../../../../components/MaterialButton";
import MaterialSelect from "../../../../components/MasterSelect";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchData } from "../../../../services";

export const MotorKeyValueForm = ({ editKeyValueData, onsubmit }) => {

  const navigate = useNavigate();
  const location = useLocation();
  const categoryId = location?.state?.categoryId || "";
  const categoryName = location?.state?.categoryName || "";
  const [keyValueData, setKeyValueData] = useState({
    // key value information
    category: "",
    keyName: "",
    parentKeyId: "",
    sortOrder: "",
    active: true,

    // key value information status
    categoryStatus: "unchecked",
    keyNameStatus: "unchecked",
    parentKeyIdStatus: "unchecked",
    sortOrderStatus: "unchecked",
  });

  const [motorCategoryOptions, setMotorCategoryOptions] = useState([]);
  const [parentKeyOptions, setParentKeyOptions] = useState([]);

  useEffect(() => {
    setKeyValueData((prev) => ({
      ...prev,
      category: { label: categoryName, value: categoryId },
      categoryStatus: categoryId ? "success" : "undefined",
    }));

    const fetchMotorCategoryData = async () => {
      try {
        const response = await fetchData(`/reference/motor/key-value-category`);

        if (response?.success) {
          setMotorCategoryOptions(
            response?.data?.items.map((item) => ({
              value: item.id,
              label: item.categoryName,
            }))
          );
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const fetchParentKeyData = async () => {
      try {
        const response = await fetchData(
          `/reference/motor/key-value-store?categoryId=${categoryId || ""}`
        );

        if (response?.success) {
          setParentKeyOptions(
            response?.data?.items.map((item) => ({
              value: item.id,
              label: item.keyName,
            }))
          );
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchMotorCategoryData();
    fetchParentKeyData();
  }, [categoryName]);

  useEffect(() => {
    if (editKeyValueData) {
      setKeyValueData(editKeyValueData);
    }
  }, [editKeyValueData]);

  const handleKeyValueDataChange = (event, selectEvent) => {
    let keyValueState = { ...keyValueData };

    const changeAllowed = true;

    if (event?.target === undefined && selectEvent) {
      switch (selectEvent.name) {
        case "category":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              keyValueState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              keyValueState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "parentKeyId":
          {
            const alphaNLenghthRegex = new RegExp(
              "^([A-Za-z0-9 -/:;@.#&]{2,20})$"
            );

            if (alphaNLenghthRegex.test(event?.label) === true) {
              keyValueState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              keyValueState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;

        default:
          break;
      }
      keyValueState[selectEvent.name] = event;
    } else if (event) {
      switch (event.target.name) {
        case "keyName":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9 ]{1,100})$");

            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              keyValueState[event.target.name + "Status"] = "success";
            } else {
              keyValueState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "sortOrder":
          {
            const alphaNLenghthRegex = new RegExp("^([0-9]{1,20})$");

            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              keyValueState[event.target.name + "Status"] = "success";
            } else {
              keyValueState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "active":
          {
            const value = event.target.value;
            keyValueState[event.target.name] = value;
          }
          break;

        default:
          break;
      }
      if (changeAllowed) {
        keyValueState[event.target.name] = event.target.value;
      }
    }
    setKeyValueData(keyValueState);
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      keyValueData.categoryStatus === "success" &&
      keyValueData.keyNameStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handleSubmit = () => {
    if (checkAllFields()) {
      onsubmit(keyValueData);
    }
  };

  return (
    <div>
      <CardContent sx={{ minHeight: "50vh" }}>
        <MaterialBox>
          <Grid container spacing={1}>
            <Grid size={{ xs: 12, sm: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Category*
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="category"
                value={keyValueData.category}
                customStyles={{ optionPadding: 20 }}
                onChange={handleKeyValueDataChange} //selectedValue, event
                options={motorCategoryOptions?.map((value) => {
                  return {
                    value: value.value,
                    label: value.label,
                  };
                })}
                error={keyValueData.categoryStatus === "error" ? true : false}
                success={
                  keyValueData.categoryStatus === "success" ? true : false
                }
                isDisabled={categoryId}
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  {categoryName} Name*
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="keyName"
                placeholder="eg. key name"
                value={keyValueData.keyName}
                onChange={handleKeyValueDataChange}
                error={keyValueData.keyNameStatus === "error" ? true : false}
                success={
                  keyValueData.keyNameStatus === "success" ? true : false
                }
              />
              {keyValueData.keyNameStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Name should be maximum 100 characters long and can contain
                    only alphabets
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Parent Key ID
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="parentKeyId"
                value={keyValueData.parentKeyId}
                options={parentKeyOptions}
                onChange={handleKeyValueDataChange}
                error={
                  keyValueData.parentKeyIdStatus === "error" ? true : false
                }
                success={
                  keyValueData.parentKeyIdStatus === "success" ? true : false
                }
              />
              {keyValueData.parentKeyIdStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Name should be maximum 20 characters long and can contain
                    only alphabets
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Sort Order
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                type="number"
                name="sortOrder"
                placeholder="eg. 1"
                value={keyValueData.sortOrder}
                onChange={handleKeyValueDataChange}
                error={keyValueData.sortOrderStatus === "error" ? true : false}
                success={
                  keyValueData.sortOrderStatus === "success" ? true : false
                }
              />
              {keyValueData.sortOrderStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Sort Order should be maximum 20 characters long and can
                    contain only number
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>

            <Grid size={{ xs: 12, sm: 2 }}>
              <MaterialBox>
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Active
                </MaterialTypography>
              </MaterialBox>
              <FormControlLabel
                control={
                  <Switch
                    name="active"
                    checked={keyValueData.active}
                    onChange={(event) =>
                      handleKeyValueDataChange({
                        target: {
                          name: "active",
                          value: event.target.checked,
                        },
                      })
                    }
                    color="primary"
                  />
                }
                label={
                  <MaterialTypography variant="caption" fontWeight="bold">
                    {keyValueData?.active ? "Yes" : "No"}
                  </MaterialTypography>
                }
                sx={{ marginLeft: 0 }}
              />
            </Grid>
          </Grid>
        </MaterialBox>
      </CardContent>
      <MaterialBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <MaterialButton
          sx={{ m: 2 }}
          variant="outlined"
          color="dark"
          onClick={() => {
            navigate("/motor-master/motor-keyValue");
          }}
        >
          Cancel
        </MaterialButton>
        <MaterialButton
          sx={{ m: 2 }}
          variant="gradient"
          color="dark"
          disabled={!checkAllFields()}
          onClick={handleSubmit}
        >
          Submit
        </MaterialButton>
      </MaterialBox>
    </div>
  );
};
